import { motion } from 'framer-motion';

const TrustpilotSection = () => {
  return (
    <section className="py-20 relative overflow-hidden bg-gradient-to-b from-neon-orange/10 to-white">
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-r from-neon-orange/20 via-white/5 to-neon-orange/20" />
        <motion.div
          className="absolute top-20 right-20 w-96 h-96 bg-neon-orange/10 rounded-full blur-3xl"
          animate={{
            scale: [1, 1.2, 1],
            opacity: [0.3, 0.6, 0.3]
          }}
          transition={{
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
        <motion.div
          className="absolute bottom-20 left-20 w-96 h-96 bg-neon-orange/10 rounded-full blur-3xl"
          animate={{
            scale: [1.2, 1, 1.2],
            opacity: [0.3, 0.6, 0.3]
          }}
          transition={{
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left side - Image */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="relative h-[400px] md:h-[450px]"
          >
            <img
              src="kev.webp"
              alt="Customer Review"
              className="rounded-xl shadow-xl w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-neon-orange/10 to-transparent rounded-xl" />
          </motion.div>

          {/* Right side - Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="space-y-6"
          >
            <div className="flex items-center gap-4 mb-8">
              <h2 className="text-4xl font-bold text-gray-900">
                Ce que nos clients disent de nous sur{' '}
                <span className="bg-gradient-to-r from-neon-orange to-red-600 bg-clip-text text-transparent">Trustpilot</span>
              </h2>
            </div>

            <p className="text-xl text-gray-700">
              Découvrez les avis vérifiés de nos clients et rejoignez notre communauté de plus de 3500 entreprises satisfaites
            </p>

            <div className="bg-white/80 backdrop-blur-sm p-8 rounded-xl shadow-lg">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <svg key={i} className="w-6 h-6 text-[#00B67A]" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>

              <p className="text-gray-700 text-lg mb-4">
                "Un support client à l'écoute, une équipe qui se soucie autant de la satisfaction du client. Avec des interventions rapides et des solutions innovantes, Couteau Suisse Digital joue un rôle important dans le développement des entrepreneurs."
              </p>

              <div className="flex justify-between items-center">
                <span className="font-semibold text-gray-900">Hatchet2698</span>
                <span className="text-gray-500">07 / 01 / 2025</span>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <div className="bg-white p-4 rounded-xl shadow-lg">
                <img
                  src="https://cdn.trustpilot.net/brand-assets/4.1.0/logo-black.svg"
                  alt="Trustpilot"
                  className="h-8"
                />
              </div>
              <motion.a
                href="https://www.trustpilot.com"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gradient-to-r from-neon-orange to-red-600 text-white px-6 py-3 rounded-full font-semibold inline-flex items-center gap-2 hover:shadow-lg hover:shadow-neon-orange/20 transition-all duration-300"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Voir tous nos avis
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </motion.a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default TrustpilotSection;
